import type { SxProps, Theme } from '@mui/material/styles';

import { Button, styled } from '@mui/material';

/** Floor width for a single `DD MMM YY` date pill with end icon. */
export const ALLOCATION_DATE_COLUMN_MIN_WIDTH = 148;

/** Estimates column width for a one-line date pill (label + end icon + padding). */
export function estimateAllocationDatePillColumnWidth(label: string): number {
  const normalized = label.trim() || '—';
  const contentWidth = Math.ceil(normalized.length * 7.5) + 48;
  return Math.max(ALLOCATION_DATE_COLUMN_MIN_WIDTH, contentWidth);
}

export function maxAllocationDatePillColumnWidth(labels: string[]): number {
  return labels.reduce(
    (max, label) => Math.max(max, estimateAllocationDatePillColumnWidth(label)),
    ALLOCATION_DATE_COLUMN_MIN_WIDTH
  );
}

/** Outlined date pill used in allocation team + inspector availability rows. */
export const allocationDatePillSx: SxProps<Theme> = {
  borderRadius: 1.5,
  textTransform: 'none',
  fontWeight: 500,
  pl: 1.25,
  pr: 1,
  py: 0.5,
  width: 'max-content',
  maxWidth: '100%',
  border: '1px solid',
  borderColor: 'divider',
  color: 'text.primary',
  boxSizing: 'border-box',
  whiteSpace: 'nowrap',
  flexShrink: 0,
  overflow: 'visible',
  textOverflow: 'clip',
  '& .MuiButton-endIcon': { ml: 0.5, mr: 0, flexShrink: 0 },
};

export const StyledButton = styled(Button)<{ $isSelected?: boolean }>(
  ({ theme, $isSelected }) => ({
    border: `${$isSelected ? '1.5px solid' : '1px solid'} ${$isSelected ? theme.palette.text.primary : `${theme.palette.grey[500]}32`}`,
    borderRadius: `${theme.spacing(2)}`,
    marginRight: `${theme.spacing(1)}`,
    ...($isSelected
      ? {
          backgroundColor: theme.palette.action.selected,
          '&:hover': {
            backgroundColor: theme.palette.action.focus,
          },
        }
      : {}),
  })
);
